import { Link } from "@tanstack/react-router";

import { Menu } from "lucide-react";
import { CartDrawer } from "./CartDrawer";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import logoAsset from "@/assets/double-lion-logo-561.png.asset.json";
import logoAssetWebp from "@/assets/double-lion-logo-561.webp.asset.json";

export function SiteHeader() {
  const mobileLinks = [
    { to: "/product/$handle" as const, params: { handle: "6x16-binoculars" }, label: "Shop" },
    { to: "/about" as const, label: "About" },
    { to: "/concepts" as const, label: "Near & Far" },
    { to: "/story" as const, label: "Story" },
    { to: "/delivery" as const, label: "Delivery" },
  ];

  const linkClass =
    "font-mono text-[11px] uppercase tracking-[0.18em] text-foreground hover:opacity-60 transition-opacity";

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-background">
      <div className="w-full px-4 md:px-8 h-14 flex items-center justify-between gap-4">
        {/* Left: logo + primary nav */}
        <div className="flex items-center gap-4 md:gap-8 min-w-0">
          <DropdownMenu>
            <DropdownMenuTrigger
              aria-label="Open menu"
              className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md text-foreground hover:bg-accent transition-colors -ml-2"
            >
              <Menu className="h-5 w-5" />
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              sideOffset={12}
              className="w-56 font-mono text-[11px] uppercase tracking-[0.2em]"
            >
              {mobileLinks.map((l) => (
                <DropdownMenuItem key={l.label} asChild>
                  {l.params ? (
                    <Link to={l.to} params={l.params} className="w-full cursor-pointer">
                      {l.label}
                    </Link>
                  ) : (
                    <Link to={l.to} className="w-full cursor-pointer">
                      {l.label}
                    </Link>
                  )}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          <Link to="/" aria-label="Double Lion home" className="flex items-center shrink-0">
            <picture>
              <source type="image/webp" srcSet={logoAssetWebp.url} />
              <img
                src={logoAsset.url}
                alt="Double Lion"
                width={561}
                height={176}
                fetchPriority="high"
                decoding="async"
                className="h-6 md:h-7 w-auto object-contain"
              />
            </picture>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/product/$handle" params={{ handle: "6x16-binoculars" }} className={linkClass}>
              Shop
            </Link>
            <Link to="/story" className={linkClass}>Story</Link>
            <Link to="/delivery" className={linkClass}>Delivery</Link>
          </nav>
        </div>

        {/* Right: utility links + cart */}
        <div className="flex items-center gap-6 md:gap-8 shrink-0">
          <Link to="/about" className={`hidden md:inline-flex ${linkClass}`}>About</Link>
          <Link to="/concepts" className={`hidden md:inline-flex ${linkClass}`}>Near &amp; Far</Link>
          <CartDrawer />
        </div>
      </div>
    </header>
  );
}

